<div id="project-content">
  <div class="content-description">
    <h2 class="section-header">PROJECTS</h2>
    <p>In this section my core skills as a software developer</p>
  </div>

  <div class="projects">
    <div class="project-item">
      <h2>Work Projects</h2>
      <div
        class="project"
        *ngFor="let workProj of WORK_PROJECTS"
        matTooltip="{{ workProj.tooltipInfo }}"
        [matTooltipPosition]="'above'"
      >
        <img src="{{ workProj.imgSrc }}" alt="" />
        <h3>{{ workProj.name }}</h3>
        <p>{{ workProj.description }}</p>
      </div>
    </div>
    <div class="project-item">
      <h2>Own Projects</h2>
      <div
        class="project"
        *ngFor="let ownProj of OWN_PROJECTS"
        matTooltip="{{ ownProj.tooltipInfo }}"
        [matTooltipPosition]="'above'"
      >
        <a href="{{ ownProj.link }}"><img src="{{ ownProj.imgSrc }}" alt="" /></a>
        <h3>{{ ownProj.name }}</h3>
        <p>{{ ownProj.description }}</p>
      </div>
    </div>
  </div>
</div>

<!-- [ngStyle]="{'background-image': 'url(' + workProj.imgSrc + ')'}" -->
